import React from 'react'
import { StyleSheet } from 'react-native'

import { GoBackButton } from '@zet/common/components/GoBackButton'
import { H4, XStack } from '@zet/design-system'

const TrainingListHeader = ({ heading }: { heading: string }) => {
  return (
    <XStack className="border-grays-30 w-screen items-center justify-between border-b bg-white px-3 py-3">
      <XStack style={styles.stackContainer} className="items-center">
        {/* TODO: Check for backgrondColor */}
        <GoBackButton
          className="mr-3 h-5 w-5 items-center justify-center rounded-lg bg-[#F5F7FB]"
          color="#050505"
          type="ArrowBack"
        />
        <H4 className="">{heading}</H4>
      </XStack>
    </XStack>
  )
}

const styles = StyleSheet.create({
  stackContainer: { width: '70%' },
})
export { TrainingListHeader }
